// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1u8QT","alert":"SettungsInbox_alert__3I_nc"};